var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"pa-4 d-flex justify-space-between align-center"},[_c('div',[_c('Breadcrumbs',{attrs:{"headline":"","link":[
          {
            text: 'Bộ môn',
            href: '/teachingDoc',
          },
          {
            text: 'Đề cương, tài liệu',
          },
        ]}})],1)]),_c('div',{attrs:{"id":"app"}},[(_vm.isLoading)?_c('div',{staticClass:"center-screen"},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary"}})],1):_vm._e(),_c('div',{staticClass:"mx-4"},_vm._l((_vm.docCategories),function(folder){return _c('TreeNoteDocCat',{key:folder.id,attrs:{"folder":folder}})}),1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }